import React, { Component } from 'react';

import './Card.scss';

export default class Card extends Component {
  render() {
    const { children } = this.props;
    return (
      <div className="Card">
        {children}
      </div>
    );
  }
}
